<script lang="ts">
    /**
     * CompanyHome - 회사 허브 메인 (/)
     *
     * 멀티 프로덕트 구조의 최상위 진입점.
     * - 회사 미션 히어로
     * - 프로덕트 카드 (JadEye / Gridverse → 각 상세 페이지)
     *
     * 기존 JadEye 랜딩 5개 섹션은 /jadeye(HomePage)로 이동했음.
     */
    import CompanyHeroSection from './sections/CompanyHeroSection.svelte';
    import ProductsSection from './sections/ProductsSection.svelte';
</script>

<!-- title·description 은 config/seo.php 가 SSOT. 서버가 head 에 렌더하고
     SPA 이동 시 LandingApp.applyMeta() 가 갱신한다. 여기서 다시 선언하면 값이 갈린다. -->

<div class="company-home">
    <CompanyHeroSection />
    <ProductsSection />
</div>

<style>
    .company-home {
        width: 100%;
    }
</style>
